import React, { useState } from 'react';
import { COURSES } from '../data/coursesData';
import ProgramCard from './ProgramCard';
import { Search, Sparkles } from 'lucide-react';

export default function ProgramsSection({ onSelectSyllabus, onApplyClick }) {
  const [activeTab, setActiveTab] = useState('ALL');
  const [searchQuery, setSearchQuery] = useState('');

  const filterTabs = [
    { id: 'ALL', label: 'All Programmes' },
    { id: 'PG', label: 'Postgraduate (PG)' },
    { id: 'UG', label: 'Undergraduate (UG)' },
    { id: 'Data & AI', label: 'Data & AI' },
    { id: 'IT & Software', label: 'IT & Software' },
    { id: 'Commerce & Finance', label: 'Commerce' },
    { id: 'Humanities & Economics', label: 'Humanities' },
  ];

  const filteredCourses = COURSES.filter(course => {
    const matchesTab = activeTab === 'ALL' || 
                       course.type === activeTab || 
                       course.category === activeTab ||
                       (activeTab === 'Humanities & Economics' && course.category.includes('Humanities'));
    const matchesSearch = course.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                          course.category.toLowerCase().includes(searchQuery.toLowerCase()) ||
                          course.subtitle.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesTab && matchesSearch;
  });

  return (
    <section id="programs" style={{ padding: '5rem 0', backgroundColor: '#F8FAFC' }}>
      <div className="container">
        
        {/* Section Header */}
        <div style={{ textAlign: 'center', maxWidth: '720px', margin: '0 auto 3rem auto' }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.4rem',
            backgroundColor: '#EFF6FF',
            color: '#1D4ED8',
            fontWeight: 700,
            fontSize: '0.82rem',
            padding: '0.35rem 0.9rem',
            borderRadius: '9999px',
            marginBottom: '0.75rem'
          }}>
            <Sparkles size={14} /> UGC Entitled Academic Degrees
          </div>
          <h2 style={{ fontSize: '2.3rem', fontWeight: 800, color: '#0F2537', letterSpacing: '-0.02em' }}>
            Explore Our UGC Entitled Online Programmes
          </h2>
          <p style={{ fontSize: '1.05rem', color: '#64748B', marginTop: '0.5rem', lineHeight: 1.6 }}>
            Designed for ambitious professionals and students. Upgrade your credentials with world-class faculty and flexible online learning.
          </p>
        </div>

        {/* Filter Tabs & Search Container */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem', marginBottom: '2.5rem' }}>
          
          {/* Search Bar */}
          <div style={{ maxWidth: '480px', margin: '0 auto', width: '100%', position: 'relative' }}>
            <input
              type="text"
              placeholder="Search by course name, domain, e.g. Data Science, BCA..."
              className="form-input"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{
                paddingLeft: '2.75rem',
                borderRadius: '9999px',
                backgroundColor: '#FFFFFF',
                borderColor: '#CBD5E1',
                color: '#0F172A',
                boxShadow: '0 4px 12px rgba(15, 23, 42, 0.05)',
                fontSize: '0.92rem'
              }}
            />
            <Search size={18} color="#94A3B8" style={{ position: 'absolute', left: '1rem', top: '50%', transform: 'translateY(-50%)' }} />
          </div>

          {/* Filter Tabs */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            flexWrap: 'wrap'
          }}>
            {filterTabs.map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: '0.55rem 1.1rem',
                  borderRadius: '9999px',
                  fontSize: '0.88rem',
                  fontWeight: activeTab === tab.id ? 700 : 500,
                  border: activeTab === tab.id ? '1.5px solid #0F2537' : '1px solid #E2E8F0',
                  backgroundColor: activeTab === tab.id ? '#0F2537' : '#FFFFFF',
                  color: activeTab === tab.id ? '#FFFFFF' : '#475569',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  boxShadow: activeTab === tab.id ? '0 4px 12px rgba(15, 37, 55, 0.2)' : 'none'
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>

        </div>

        {/* Programs Grid */}
        {filteredCourses.length > 0 ? (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
            gap: '2rem'
          }}>
            {filteredCourses.map(course => (
              <ProgramCard
                key={course.id}
                course={course}
                onSelectSyllabus={onSelectSyllabus}
                onApplyClick={onApplyClick}
              />
            ))}
          </div>
        ) : (
          <div style={{
            textAlign: 'center',
            padding: '4rem 2rem',
            backgroundColor: '#FFFFFF',
            borderRadius: '16px',
            border: '1px dashed #CBD5E1'
          }}>
            <h3 style={{ fontSize: '1.2rem', color: '#0F2537', fontWeight: 700 }}>No matching programs found</h3>
            <p style={{ fontSize: '0.9rem', color: '#64748B', marginTop: '0.35rem' }}>
              Try searching with another keyword or reset the filter tabs.
            </p>
            <button
              onClick={() => { setActiveTab('ALL'); setSearchQuery(''); }}
              className="btn-outline"
              style={{ marginTop: '1rem' }}
            >
              Reset Filters
            </button>
          </div>
        )}

      </div>
    </section>
  );
}
